// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"ec7a1ee4","408":"0a090a0f","453":"451cbef2"}[chunkId] + ".chunk.js";
};